'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const TableReallocateError = () => {
  return (
    <div data-testid="vault-reallocations-error">
      <ErrorDataUnavailable minHeight="378px" />
    </div>
  )
}

export default memo(TableReallocateError)
